import axios from "axios"

export const DateAndTimeService = Object.freeze({
  GetAvailableMonths: function (numberOfMonths, cultureCode) {

    var reqUrl = "localization/GetAvailableMonths"
    var parameters = "?numberOfMonths=" + numberOfMonths
    if (cultureCode !== undefined) {
      parameters += "&culture=" + cultureCode
    }
    return axios.get(window.appGlobals.API_URL + reqUrl + parameters)
  }
})
